import React, { useEffect } from 'react'
import { debounce } from 'lodash-es'
import tw from 'twin.macro'
import styled from '@emotion/styled'
import { FormItem, Button } from '@ow/comps'
import { IconMaps } from '@ow/icons'
import { Controller } from 'react-hook-form'
import clsx from 'clsx'
import useFilter from './use-filter-ex'
import FilterItem from './FilterItem'

const StyledExpandBtn = styled.div`
  cursor: pointer;
  margin-left: 20px;
  span {
    font-size: var(--font-size-sm);
    color: var(--ow-color-primary-700);
  }
  ${tw`flex items-center`}
`

const RenderContent = function ({
  showFilters,
  getCurrentQuery,
  fieldIsDisabled,
  control,
  getFieldDef,
  onFetchRemoteData,
  defaultValue,
  showSearch,
}) {
  return showFilters.map((filter, index) => {
    // console.log('[fixed-filter]', filter, index)
    const { queryTypes } = getCurrentQuery(index)
    const { opts, valueStyle, hiddenTitle, hiddenQueryType, hiddenItem } =
      filter
    return (
      <Controller
        key={index}
        name={`queries.${index}`}
        control={control}
        render={({ field }) => {
          const fieldDef = getFieldDef(filter)
          return (
            <FormItem
              // label={
              //   !filter.hiddenTitle && (
              //     <div
              //       style={{
              //         color: '#8094ae',
              //         fontSize: '13px',
              //         marginRight: '10px',
              //       }}
              //     >
              //       {(opts && opts.title) || fieldDef.title}
              //     </div>
              //   )
              // }
              direction="row"
              className={clsx([
                'lg:flex-row lg:items-center py-1 lg:py-2 items-center',
                // 平铺的筛选各自占一行
                opts && opts.type === 'select' && 'w-full',
              ])}
            >
              <FilterItem
                // filterField={
                //   opts
                //     ? {
                //         ...opts,
                //         selects: fieldDef.selects || opts.selects,
                //         title: opts.title || fieldDef.title,
                //         slug,
                //       }
                //     : {
                //         ...fieldDef,
                //         hint: hiddenTitle && fieldDef.title,
                //         slug,
                //       }
                // }
                filterField={{
                  ...fieldDef,
                  ...opts,
                  selects: (opts && opts.selects) || fieldDef.selects,
                  hint: hiddenTitle && fieldDef.title,
                }}
                onFetchRemoteData={onFetchRemoteData}
                filters={defaultValue}
                {...field}
                value={{ ...field.value }}
                alowedqueryTypes={queryTypes}
                hiddenQueryType={hiddenQueryType}
                hiddenItem={hiddenItem || false}
                valueStyle={valueStyle}
                fieldIsDisabled={fieldIsDisabled}
              />
            </FormItem>
          )
        }}
      />
    )
  })
}

export default function Fixed({
  fields,
  fixedFilters,
  onChange,
  // tbDataState,
  onFetchRemoteData,
  defaultValue,
  tbs,
  showSearch,
}) {
  // const [filters, setFilters] = useState(fixedFilters)
  const { fixedSlug, fixedSlugNum } = fixedFilters

  const {
    control,
    watch,
    allFilters,
    fixedShowFilters,
    fieldsMap,
    getCurrentQuery,
    fieldIsDisabled,
    commitFilters,
    resetFilters,
    isNeedExpand,
    isExpand,
    setIsExpand,
  } = useFilter(
    fields,
    fixedSlug || [],
    fixedFilters,
    defaultValue,
    tbs,
    fixedSlugNum
  )
  const getFieldDef = (field) => fieldsMap[field.slug] || {}

  const handleSearch = () => {
    if (onChange) {
      onChange(commitFilters(), null, false)
    }
  }
  const handleReset = () => {
    if (onChange) {
      onChange(resetFilters(), true)
    }
  }

  // const debounced = useCallback(
  //   debounce(
  //     (value, { name, type }) => console.log('filters-233', value, name, type),
  //     700,
  //     { leading: false, trailing: true }
  //   ),
  //   [onChange]
  // )

  useEffect(() => {
    // if (!showSearch) {
    const subscription = watch(
      debounce(
        (value, { name, type }) => {
          console.log('rangevalue-233', value, name, type)
          if (type) {
            onChange(commitFilters())
          }
        },
        700,
        { leading: false, trailing: true }
      )
    )
    return () => subscription.unsubscribe()
    // }
  }, [watch])

  return (
    <div className="w-full flex flex-wrap flex-row justify-start items-center fixedBox">
      <RenderContent
        showFilters={isExpand ? allFilters : fixedShowFilters}
        getCurrentQuery={getCurrentQuery}
        fieldIsDisabled={fieldIsDisabled}
        control={control}
        getFieldDef={getFieldDef}
        onFetchRemoteData={onFetchRemoteData}
        defaultValue={defaultValue}
      />
      {allFilters && allFilters.length > 0 && (
        <>
          {/* {showSearch && (
            <Button
              stroke
              onClick={handleSearch}
              className="dark:bg-darkTheme-800 dark:border-darkTheme-1100 dark:text-dark-200 mr-2"
            >
              查询
            </Button>
          )} */}
          {!fixedFilters.hiddenReset && (
            <Button
              stroke
              onClick={handleReset}
              className="dark:bg-darkTheme-800 dark:border-darkTheme-1100 dark:text-dark-200"
            >
              重置
            </Button>
          )}
        </>
      )}
      {isNeedExpand(fixedShowFilters) && (
        <StyledExpandBtn
          onClick={() => {
            setIsExpand(!isExpand)
          }}
          className="expand-btn"
        >
          <span>{isExpand ? '收起' : '展开'}</span>
          <div style={{ transform: `${isExpand ? 'rotate(180deg)' : ''}` }}>
            <IconMaps
              type="expandIcon"
              // type={isExpand ? 'retractIcon' : 'expandIcon'}
              width={16}
              height={16}
              fill="var(--ow-color-primary-700)"
            />
          </div>
        </StyledExpandBtn>
      )}
    </div>
  )
}
